/**
 * The colour each of Engagement's label hues paints.
 *
 * Engagement stores an administrator's choice as the name of one of its own CSS classes, which the
 * host resolves in its stylesheet (`app_style.scss`, `.label-md-<hue>-bg`) — a stylesheet the
 * Performance module never loads, since it renders inside a shadow root. These are that
 * stylesheet's values, read from it rather than picked again, so the administrator's choice reaches
 * the portal unchanged instead of being flattened to a neutral pill.
 */
const LABEL_COLORS: Readonly<Record<string, string>> = {
    red: '#f44336',
    pink: '#e91e63',
    purple: '#9c27b0',
    'deep-purple': '#673ab7',
    indigo: '#3f51b5',
    blue: '#2196f3',
    'light-blue': '#03a9f4',
    cyan: '#00bcd4',
    teal: '#009688',
    green: '#4caf50',
    'light-green': '#8bc34a',
    lime: '#cddc39',
    yellow: '#ffeb3b',
    amber: '#ffc107',
    orange: '#ff9800',
    'deep-orange': '#ff5722',
    brown: '#795548',
    gray: '#9e9e9e',
    'blue-grey': '#607d8b',
    'second-last': '#3470ca',
    last: '#3c4252',
};

/**
 * The colour of a praise card's label, or nothing for a hue this palette does not know — the card
 * then draws its default pill rather than a colour invented here.
 */
export const getRecognitionLabelColor = (labelColor?: string): string | undefined =>
    labelColor ? LABEL_COLORS[labelColor] : undefined;
